import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible/flexible";
import "./utils/untitled";
// document.documentElement.style.fontSize = window.innerWidth / 7.5 + "px";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
